import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import type { LeadFormProps, LeadFormStepFields } from "@/component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { BasicLeadForm } from "@/component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { ProgressButton } from "@/shared/ui";

interface Props extends LeadFormProps {}

export interface StepFields extends LeadFormStepFields {
	lastName: string;
	firstName: string;
	email: string;
	phone: string;
	cityName: string;
	cityId?: number;
}

export class LeadForm extends BasicLeadForm<StepFields, Props> {
	public static defaultProps = {
		...BasicLeadForm.defaultProps,
		title: <>A részletes eredményedet e-mailben fogjuk elküldeni!</>,
	};

	protected initValues(): StepFields {
		return {
			lastName: undefined,
			firstName: undefined,
			cityName: undefined,
			phone: undefined,
			email: undefined,
			cityId: undefined,
		};
	}

	protected renderContent(_values: StepFields, _form: FormApi<StepFields, Partial<StepFields>>): ReactNode {
		return (
			<>
				{this.renderHeader()}
				<Card.Body className="bg-white text-dark">
					{super.renderFields()}
					{super.renderCheckboxes()}
				</Card.Body>
				<Card.Footer className="text-center bg-white">
					<div className="text-dark mb-2">{super.renderPrivacyStatement()}</div>
					<ProgressButton
						type="submit"
						variant="primary"
						className="font-weight-bold"
						block
						disabled={super.isDisabled()}
					>
						Elküldöm
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	protected renderHeader(): ReactNode {
		const { title } = this.props;

		if (!title) {
			return null;
		}

		return (
			<Card.Header className="bg-primary rounded-top">
				<div className="h4 mb-0 text-center">{title}</div>
			</Card.Header>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
